/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react"
import { styled , Typography, Tooltip } from "@mui/material"
import { tooltipClasses } from '@mui/material/Tooltip';
import { fonts, colors, styles } from "../../themes/dashboard";
import { InfoCircleOutlined } from "@ant-design/icons";

export const statisticsContainerStyles = (
  theme,
  largeScreenColumnCount = 3,
  mediumLargeScreenColumnCount = 2
) => ({
  display: "grid",
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  borderRadius: 2,
  marginTop: 0,
  overflow: 'hidden',
  boxShadow: styles?.boxShadow,

  ...(mediumLargeScreenColumnCount > 2 ? {
    [theme.breakpoints.between(1000, 'lg')]: {
      gridTemplateColumns: `repeat(${mediumLargeScreenColumnCount}, minmax(0, 1fr))`,
    },
  } : {}),

  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: `repeat(${largeScreenColumnCount}, minmax(0, 1fr))`,
  },
})


export const StatisticsTitle = styled(Typography)({
  fontSize: '14px',
  fontFamily: fonts?.fontFamily,
  color: '#71717A',
  fontWeight: '500',
  letterSpacing: '0px'
})

export const StatisticsValue = styled(Typography)({
  fontSize: '20px',
  fontFamily: fonts?.fontFamily,
  fontWeight: '600',
  letterSpacing: '0px'
})

export const CardContainer = styled('div', { 
    shouldForwardProp: (prop) => prop !== 'isMobile'
  })(({ isMobile }) => ({
    height: '100%',
    width: '100%',
    display: 'flex',
    gap: '15px',
    alignItems: isMobile ? 'flex-start' : 'center',
    padding: isMobile ? '0px' : '0px 10px',
    flexDirection: isMobile && 'column'
}))

export const IconContainer = styled('div')({
  height: '52px', 
  width: '52px', 
  backgroundColor: '#fff7ed', 
  borderRadius: '8px', 
  display: 'flex', 
  justifyContent: 'center', 
  alignItems: 'center',
})

export const InformationContainer = styled('div', {
    shouldForwardProp: (prop) => prop !== 'isMobile' 
  })(({ isMobile }) => ({
    display: 'flex',
    flexDirection: 'column', 
    flex: 1,
    width: isMobile && '100%',
}))

export const TitleContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between'
})

export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: '14px',
    padding: '12px',
    maxWidth: '214px',
    fontFamily: fonts?.fontFamily,
    fontWeight: '400',
    letterSpacing: '0px',
  },
}));

export const StyledInfoIcon = styled(InfoCircleOutlined)({
  color: colors.infoColor,
})
